import * as configcat from "configcat-js";

const configcatFactory = (() => {
    let instance;

    return {
        getInstance: () => {
            if (!instance) {
                instance = configcat.createClient(process.env.CONFIGCAT_SDK_KEY || "oATZCBV2vE2JMSUW4e3wrQ/_UPi7VaMUECqXFDRgkOSjQ", {
                    dataGovernance: configcat.DataGovernance.EuOnly,
                    logger: configcat.createConsoleLogger(process.env.CONFIGCAT_LOG_LEVEL || -1),
                    pollIntervalSeconds: process.env.CONFIGCAT_POLL_INTERVAL || 60
                });
            }
            return instance;
        }
    };
})();

export const configcatClient = configcatFactory.getInstance();
